import React, { Component } from 'react'
import i18n from '../i18n.json'

const formatAmount = (amount, discount, decimals, ceil) => {
  if (ceil)
    return Math.ceil(amount / (1 - discount)).toFixed(decimals)
   return (amount / (1 - discount)).toFixed(decimals)
}

class Pricing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userLocation: null,
      availableProducts: this.props.availableProducts,
      loading: false
    }
  }

  componentWillMount() {
    this.setState({
      loading: true
    })
    this.callAvailableProducts()
    // .then(() => {
    //   this.setState({
    //     loading: false
    //   })
    // })
    // .catch((error) => {
    //   this.setState({
    //     loading: false
    //   })
    // })
  }

  componentDidMount() {
    if (this.state.userLocation) return
    let url = 'https://freegeoip.net/json/'
    fetch(url)
      .then((response) => response.json())
      .then((responseJson) => {
        let { country_code } = responseJson
        if (country_code) {
          if (country_code === 'BR')
            this.props.updateLanguage('pt')
          else
            this.props.updateLanguage('en')
          this.setState({
            userLocation: country_code
          })
        }
      })
      .catch((error) => {
        // console.error(error)
      })
  }

  componentDidUpdate(prevProps, prevState) {
    let prevSelectedLanguage = prevProps.newLogo.userPrefs.selectedLanguage
    let { selectedLanguage } = this.props.newLogo.userPrefs
    if (prevSelectedLanguage !== selectedLanguage) {
      this.callAvailableProducts()
    }
  }

  callAvailableProducts = () => {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    let locale = 'en_US'
    if (selectedLanguage === 'pt') locale = 'pt_BR'
    this.props.getAvailableProducts({locale: locale})
  }


  renderNav() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div className="nav">
        <ul>
          <li className="left-corner">
            <a id="automagic-logo" href="/">
              automagic<br />.design
            </a>
          </li>
          <li>
              <a href="/">
                <div className="padding-bottom">
                  <h2><i className="fa fa-plus-square-o"></i></h2>
                  { i18n[selectedLanguage]['dashboard-menu-new-logo'] }
                </div>
              </a>
          </li>
        </ul>

      </div>
    )
  }

  renderBottom() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
        <div>
         <div className="bottom bottom-left">
          <a href="/about">{ i18n[selectedLanguage]['bottom-about'] }</a> |
          <a href="/pricing"> { i18n[selectedLanguage]['bottom-pricing'] }</a> |
          <a href="mailto:contact@automagic.design"> { i18n[selectedLanguage]['bottom-contact'] }</a> |
          <a href="/tos"> { i18n[selectedLanguage]['bottom-tos'] }</a> |
          <a href="/privacy"> { i18n[selectedLanguage]['bottom-privacy'] }</a>
         </div>
         <div className="bottom bottom-right">
          <a className="language-selector" href="/en" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('en') } }> EN</a> |
          <a className="language-selector" href="/pt" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('pt') } }> PT-BR</a>
         </div>
        </div>
    )
  }

  renderPage() {
    let availableProducts = this.props.availableProducts
    if (!availableProducts) return null
    if (availableProducts.length < 1) return null

    const discounts = {
      en: [0.5, 0.3, 0.3],
      pt: [0.5, 0.3, 0.3, 0.3, 0.3]
    }
    let { selectedLanguage } = this.props.newLogo.userPrefs
    let currency = availableProducts[0].currency === 'BRL' ? 'R$' : '$'
    availableProducts.sort((a, b) => { return a.uid - b.uid })
    let plansColumns = availableProducts.map((product, index) => {
      let { name, amount } = product
      let discount = discounts[selectedLanguage][index]
      let { descriptions, subtitle } = i18n[selectedLanguage]["products"][name]

      // <h2><span className="price-currency">3x { currency }</span> { formatAmount(amount/3, 0, 0, false) }</h2>
      return (
        <div className="col-2 col-plan">
          <div className="banner-price" id="banner-price-1">
            { (name === "Logo")
              ?
                <div className="on-sale"><div className="stripe-green">{i18n[selectedLanguage]['limited']}</div></div>
              :
                (name === "Cartão" || name === "Web")
                ?
                  <div className="on-sale"><div className="stripe-pink">{i18n[selectedLanguage]['new']}</div></div>
                :
                  <div className="on-sale-top"></div>
            }
            <h1><span className="plus-plan-name"></span>{ name }</h1>
            <span>
              <h3 className="original-price">{currency} {formatAmount(amount, discount, 0, true)}</h3>
              <h3 className="discount">{ i18n[selectedLanguage]['save'] } { discount * 100 }%</h3>
              <h2><span className="price-currency"> { currency }</span> { amount }</h2>
              <h3 className="discount-launch">{ i18n[selectedLanguage]['launch-price'] }</h3>
            </span>
          </div>

          <div className="banner-subtitle">
            { subtitle }
          </div>

          <ul className="about-list">
            {
              descriptions.map((desc) => {
                return (
                  <li className="product-description">{ desc }</li>
                )
              })
            }
          </ul>
        </div>
      )
    })

    let faqSection = (
      <div className="download-section" id="faq-section">
        <h1>{ i18n[selectedLanguage]['faq-title'] }</h1>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-register'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-register'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-unique'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-unique'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-same'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-same'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-receive'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-receive'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-couldnotfound'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-couldnotfound'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-refund'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-refund'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-freeshipping'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-freeshipping'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-printshipping'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-printshipping'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-paperquality'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-paperquality'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-nothome'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-nothome'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-editafter'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-editafter'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-digitalproduction'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-digitalproduction'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-paymentmethod'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-paymentmethod'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-safe'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-safe'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-fone'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-fone'] }</p>
          </div>
        </div>
        <div className="flex-row">
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-office'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-office'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-mission'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-mission'] }</p>
          </div>
          <div className="col-4">
            <h2>{ i18n[selectedLanguage]['faq-question-morequestions'] }</h2>
            <p>{ i18n[selectedLanguage]['faq-answer-morequestions'] }</p>
          </div>
        </div>
      </div>
    )

    return (
      <div className="download-section" id="pricing-section">
        <div className="flex-row" style={{ justifyContent: "center" }}>
          <div className="col-11">
            <h1 style={{ lineHeight: "2em"}}>
              { i18n[selectedLanguage]['pricing-title'] }
            </h1>
          </div>
         </div>
        <div className="flex-row" style={{ justifyContent: "center" }}>
          <div className="col-11">
            <h2>
              { i18n[selectedLanguage]['pricing-subtitle'] }
            </h2>
           </div>
        </div>
        <div className="flex-row" style={{ justifyContent: "center", alignItems: "flex-start", padding: "100px 20px"}}>
          { plansColumns }
        </div>

        {faqSection}

        <div className="flex-row" id="contact-pricing">
          <div className="col-10">
            <a id="contact-link" href="mailto:contact@automagic.design">
              <h1>
                { i18n[selectedLanguage]['pricing-contact'] }
              </h1>
            </a>
           </div>
        </div>

      </div>
    )
  }

  render() {
    return (
      <div>
        { this.renderNav() }

        { this.renderPage() }

        { this.renderBottom() }
      </div>
    )
  }

}

export default Pricing



// WEBPACK FOOTER //
// ./src/components/Pricing.js